import { MARTINA_RUN_OBSERVE_BUDGET_EXCEEDED } from "@/components/exai/martinaRunObserve";

export const MARTINA_RUN_NOT_FOUND_CODE = "MARTINA_RUN_NOT_FOUND";
export const MARTINA_RUN_DELIVERY_RECONNECT_REQUIRED = "MARTINA_RUN_DELIVERY_RECONNECT_REQUIRED";
export { MARTINA_RUN_OBSERVE_BUDGET_EXCEEDED };

type PersistentRunErrorLike = {
  code?: unknown;
  status?: unknown;
  message?: unknown;
};

function errorText(error: unknown): string {
  if (typeof error === "string") return error;
  if (!error || typeof error !== "object") return String(error ?? "");
  const candidate = error as PersistentRunErrorLike;
  return typeof candidate.message === "string" ? candidate.message : String(error);
}

export function persistentRunErrorCode(error: unknown): string | undefined {
  if (error && typeof error === "object") {
    const code = (error as PersistentRunErrorLike).code;
    if (typeof code === "string" && code) return code;
    const status = (error as PersistentRunErrorLike).status;
    if (status === 404) return MARTINA_RUN_NOT_FOUND_CODE;
  }
  const text = errorText(error);
  if (text.includes(MARTINA_RUN_NOT_FOUND_CODE)) return MARTINA_RUN_NOT_FOUND_CODE;
  if (text.includes(MARTINA_RUN_DELIVERY_RECONNECT_REQUIRED)) return MARTINA_RUN_DELIVERY_RECONNECT_REQUIRED;
  if (text.includes(MARTINA_RUN_OBSERVE_BUDGET_EXCEEDED)) return MARTINA_RUN_OBSERVE_BUDGET_EXCEEDED;
  return undefined;
}

/**
 * A persisted pointer is no longer recoverable when the server says the run
 * does not exist. Delivery reconnect failures keep the pointer so Riprova can
 * resume the accepted job instead of minting a duplicate enqueue.
 */
export function shouldInvalidatePersistentRun(error: unknown): boolean {
  const code = persistentRunErrorCode(error);
  return code === MARTINA_RUN_NOT_FOUND_CODE
    || code === MARTINA_RUN_DELIVERY_RECONNECT_REQUIRED
    || code === MARTINA_RUN_OBSERVE_BUDGET_EXCEEDED;
}

export function shouldClearPersistentRunPointer(error: unknown): boolean {
  return persistentRunErrorCode(error) === MARTINA_RUN_NOT_FOUND_CODE;
}

export function persistentRunRecoveryMessage(error: unknown): string {
  const code = persistentRunErrorCode(error);
  if (code === MARTINA_RUN_NOT_FOUND_CODE) {
    return "La richiesta precedente non è più attiva. Martina è pronta: puoi inviare di nuovo la domanda.";
  }
  if (code === MARTINA_RUN_OBSERVE_BUDGET_EXCEEDED) {
    return "Il turno non ha chiuso entro il budget di osservazione. Non so ancora l'esito definitivo: usa Riprova per riconnetterti senza duplicare la richiesta.";
  }
  return "La connessione al turno precedente è scaduta. Il run resta attivo: usa Riprova per riconnetterti senza duplicare la richiesta.";
}
